module.exports = __webpack_public_path__ + "img/newsImg11-11.98456d55.png";